import React from 'react';
import Footer from '@components/shared/Footer/Footer';
import { useTexts } from 'utils/useTexts';
import OfferSelectionForm from '@components/OfferSelectionForm/OfferSelectionForm';

const OfferSelection = () => {
  const { t } = useTexts();

  return (
    <>
      <OfferSelectionForm />
      <Footer text={t('offerSelection.footer')} />
    </>
  );
};

export default OfferSelection;
